import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { FooterComponent } from 'app/layout/components/footer/footer.component';
import { FuseSharedModule } from '../../../../@fuse/shared.module';

@NgModule({
    declarations: [
        FooterComponent
    ],
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        FuseSharedModule,
        CommonModule
    ],
    exports: [
        FooterComponent
    ]
})
export class FooterModule {
}
